import { width } from "@mui/system";
import React, { useState, useRef } from "react";
import { View, Text, StyleSheet, ScrollView, SafeAreaView, Image, TouchableOpacity, FlatList } from "react-native";
import { Picker, SectionList } from "react-native-web";
import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Icon from 'react-native-vector-icons/FontAwesome';
import { useTranslation } from 'react-i18next';
import { i18n } from './../../../assets/lang/i18next';
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { ComponentToPrintCondonser } from "../../../Components/ComponentToPrintCondensorjs";
import ReactToPrint from 'react-to-print';
const useStyles = makeStyles(() => ({
    textField: {
        width: "100%",
        marginTop: 20,
        marginLeft: "auto",
        marginRight: "auto",
        paddingBottom: 0,
        marginTop: 0,
        fontWeight: 500,
        fontSize: 13,
        direction: "rtl",
        "& .MuiFormLabel-root": {
            color: "black",
            textAlign: 'right',
            fontFamily: 'IranSans',
            fontSize: 13, direction: 'rtl', width: '100%',
        },
        "& .MuiInputLabel-asterisk": {
            color: 'red',
            fontWeight: 900,
        },
        "& .MuiInputBase-input": {
            color: '#333', textAlign: 'center'
        },
        '& label.Mui-focused': {
            color: '#333',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'yellow',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'white',
            },
            '&:hover fieldset': {
                borderColor: 'blue',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#333',
            },
        },

    },
    labelRoot: {
        right: 20,
    },
    shrink: {
        transformOrigin: "top right",
    },
    input: {
        color: "black", fontFamily: 'IranSans',
        fontSize: 13,

    },
    btn_calculate: {
        color: '#333',
        backgroundColor: 'gray',
        fontFamily: 'IranSans',
        fontSize: 13, fontWeight: 900,
    }
}));
const ResultCondenser = props => {
    const { t, i18n } = useTranslation();
    const componentRef = useRef();
    const classes = useStyles();
    const [selectwhich, Setselectwich] = useState(1);
    const [dataevap, setEvapData] = useState(() => { item => setEvapData(item) });
    const [itemsEvapTemp, setEvapTempItems] = useState([]);
    const [selectevaprator, Setselectevaprator] = useState(0);
    const [datacondflat, setCondFlat] = useState([]);
    const [selectedId, setSelectedId] = useState(null);
    const [selectedmodeltitle, setSelectedModelTitle] = useState("");
    if (props.route.params.WHICH == 1) {
        //کندانسور افقی 4 5 محاسبه        
        fetch(`https://app.arshehkar.com/query/public/GetListCondenserQn.php?qn=${props.route.params.QN}&model=HCH&seri=45`)
            .then(response => response.json())
            .then(async (datacondflat) => {
                setCondFlat(datacondflat);
            });
    }
    else
        if (props.route.params.WHICH == 2) {
            //  کندانسور افقی 4 5 کمپرسور
            fetch(`https://app.arshehkar.com/query/public/GetListCondenserQn.php?qn=${props.route.params.QN}&model=HCH&seri=45`)
                .then(response => response.json())
                .then(async (datacondflat) => {
                    setCondFlat(datacondflat);
                });
        }
        else
            if (props.route.params.WHICH == 3) {
                //  کندانسور عمودی 4 5 محاسبه
                fetch(`https://app.arshehkar.com/query/public/GetListCondenserQn.php?qn=${props.route.params.QN}&model=HCS&seri=45`)
                    .then(response => response.json())
                    .then(async (datacondflat) => {
                        setCondFlat(datacondflat);
                    });
            }
            else
                if (props.route.params.WHICH == 20) {
                    //  کندانسور عمودی 4 5 کمپرسور
                    fetch(`https://app.arshehkar.com/query/public/GetListCondenserQn.php?qn=${props.route.params.QN}&model=HCS&seri=45`)
                        .then(response => response.json())
                        .then(async (datacondflat) => {
                            setCondFlat(datacondflat);
                        });
                }
                else
                    if (props.route.params.WHICH == 4) {
                        //  کندانسور افقی 8 محاسبه
                        fetch(`https://app.arshehkar.com/query/public/GetListCondenserQn.php?qn=${props.route.params.QN}&model=HCH&ghotr=80`)
                            .then(response => response.json())
                            .then(async (datacondflat) => {
                                setCondFlat(datacondflat);
                            });
                    }
                    else
                        if (props.route.params.WHICH == 5) {
                            //  کندانسور عمودی 8 محاسبه
                            fetch(`https://app.arshehkar.com/query/public/GetListCondenserQn.php?qn=${props.route.params.QN}&model=HCS&ghotr=80`)
                                .then(response => response.json())
                                .then(async (datacondflat) => {
                                    setCondFlat(datacondflat);
                                });
                        }
                        else
                            if (props.route.params.WHICH == 6) {
                                //  کندانسور آرتک محاسبه
                                fetch(`https://app.arshehkar.com/query/public/GetListCondenserQn.php?qn=${props.route.params.QN}&model=S&brand=ARTEC`)
                                    .then(response => response.json())
                                    .then(async (datacondflat) => {
                                        setCondFlat(datacondflat);
                                    });
                            }
                            else
                                if (props.route.params.WHICH == 21) {
                                    //  کندانسور آرتک کمپرسور
                                    fetch(`https://app.arshehkar.com/query/public/GetListCondenserQn.php?qn=${props.route.params.QN}&model=S&brand=ARTEC`)
                                        .then(response => response.json())
                                        .then(async (datacondflat) => {
                                            setCondFlat(datacondflat);
                                        });
                                }
    const [zarfiyatnami, setzarfiyatnami] = useState("-");
    const [sathtabadolhararat, setsathtabadolhararat] = useState("-");
    const [gazgiri, setgazgiri] = useState("-");
    const [tedadfan, settedadfan] = useState("-");
    const [ghotrefan, setghotrefan] = useState("-");
    const [debi, setdebi] = useState("-");
    const [faselefin, setfaselefin] = useState("-");
    const [vorodi, setvorodi] = useState("-");
    const [khoroji, setkhoroji] = useState("-");
    const [vazn, setvazn] = useState("-");
    const [sorat, setsorat] = useState("-");
    const [ip, setip] = useState("-");
    const [voltajfan, setvoltajfan] = useState("-");
    const [ferekans, setferekans] = useState("-");
    const [jaryanfan, setjaryanfan] = useState("-");
    const [tavanfan, settavanfan] = useState("-");
    const [vorodireciver, setvorodireciver] = useState("-");
    const [khorojireciver, setkhorojireciver] = useState("-");
    const [urlshematic, seturlshematic] = useState("-");
    const [urlshematickotah, seturlshematickotah] = useState("-");
    const [urlshematicboland, seturlshematicboland] = useState("-");
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenShort, setIsOpenShort] = useState(false);
    function GetInfoEvaprator(idevap) {
        if (idevap != 0) {
            fetch(`https://app.arshehkar.com/query/public/GetInfoCondonserById.php?id=${idevap}`)
                .then(response => response.json())
                .then(async (responseJsontmp) => {
                    setzarfiyatnami(responseJsontmp["zarfiyatnami"]);
                    setsathtabadolhararat(responseJsontmp["sathtabadolhararat"]);
                    setgazgiri(responseJsontmp["gazgiri"]);
                    settedadfan(responseJsontmp["tedadfan"]);
                    setghotrefan(responseJsontmp["ghotrefan"]);
                    setdebi(responseJsontmp["debi"]);
                    setfaselefin(responseJsontmp["faselefin"]);
                    setvorodi(responseJsontmp["vorodi"]);
                    setkhoroji(responseJsontmp["khoroji"]);
                    setvazn(responseJsontmp["vazn"]);
                    setsorat(responseJsontmp["sorat"]);
                    setip(responseJsontmp["ip"]);
                    setvoltajfan(responseJsontmp["voltajfan"]);
                    setferekans(responseJsontmp["ferekans"]);
                    setjaryanfan(responseJsontmp["jaryanfan"]);
                    settavanfan(responseJsontmp["tavanfan"]);
                    setvorodireciver(responseJsontmp["vorodireciver"]);
                    setkhorojireciver(responseJsontmp["khorojireciver"]);
                    seturlshematicboland(responseJsontmp["shematicboland"]);
                    seturlshematic(responseJsontmp["shematicboland"]);
                    seturlshematickotah(responseJsontmp["shematickotah"]);
                })
        }
    }

    return (
        <ScrollView>
            <SafeAreaView style={styles.container}>
                <Text style={{ fontFamily: 'IranSans', fontSize: 13.8, padding: 10, marginRight: 10, color: 'black', fontWeight: 700 }}>{t('suggestedCondensers')}</Text>


                <FlatList
                    data={datacondflat}
                    numColumns={2}
                    keyExtractor={(item) => item.id}
                    extraData={selectedId}
                    style={{ margin: 4, width: '90%', }}
                    renderItem={({ item }) => {
                        const backgroundColor = item.id === selectedId ? "#d12023" : "#d6d6d6";
                        return (
                            <TouchableOpacity style={{
                                flex: 1,
                                flexDirection: 'column', justifyContent: 'center', alignContent: 'center', alignItems: 'center', marginVertical: 8,
                                marginHorizontal: 8, backgroundColor: backgroundColor, padding: 8, borderRadius: 3
                            }} onPress={() => {
                                setSelectedId(item.id);
                                Setselectevaprator(item.id);
                                GetInfoEvaprator(item.id);
                                setSelectedModelTitle(item.model_title);

                            }}>
                                <Text>{item.model_title}</Text>
                                <Text style={{ textAlign: 'left', fontSize: 11, color: 'dark', display: 'flex', position: 'relative', fontFamily: 'IranSans', }}>{t('SafetyFactor')}    [ {(item.zarfiyatnami / props.route.params.QN).toFixed(2)} ]</Text>
                            </TouchableOpacity>
                        )
                    }

                    }
                />
                {datacondflat.length <= 0 ? <View style={{ marginBottom: 25 }}><Text style={{ fontFamily: 'IranSans', fontSize: 15, color: '#d12023' }}>{t('NOCondenserFoundedUnderThisCondition')}</Text></View> : null}
                {datacondflat.length > 0 ?
                    <View style={{ flex: 1, flexDirection: 'row', width: '90%', marginBottom: 30 }}>
                        <View style={{ flex: 1, flexDirection: 'column' }}>
                            <TouchableOpacity style={styles.touchable}
                                onPress={() => Setselectwich(3)}
                            ><Icon name={"arrow-down"} color={"black"} size={16} />
                                <Text style={styles.titleheader}>{t('schematic')}</Text>
                            </TouchableOpacity>
                        </View>
                        <View style={{ flex: 1, flexDirection: 'column' }}>
                            <TouchableOpacity style={styles.touchable}
                                onPress={() => Setselectwich(2)}
                            ><Icon name={"arrow-down"} color={"black"} size={16} />
                                <Text style={styles.titleheader}>{t('Technicaldata')}</Text>
                            </TouchableOpacity>
                        </View>
                        <View style={{ flex: 1, flexDirection: 'column' }}>
                            <TouchableOpacity style={styles.touchable}
                                onPress={() => Setselectwich(1)}
                            ><Icon name={"arrow-down"} color={"black"} size={16} />
                                <Text style={styles.titleheader}>{t('Specifications')}</Text>
                            </TouchableOpacity>
                        </View>



                    </View>
                    : null}
                {selectwhich == 1 && datacondflat.length > 0 ?
                    <View style={[styles.container, { width: '100%' }]}>



                        <View style={styles.header}>
                            <Text style={styles.titleheader}>{t('Specifications')}</Text>
                        </View>



                        <View style={styles.form}>
                            <Text style={styles.titleform}>{t('KW')}</Text>
                            <Text style={styles.titleform}>{zarfiyatnami}</Text>
                            <Text style={styles.titleform}>{t('Nominalcapacity')}</Text>
                        </View>

                        <View style={styles.formodd}>
                            <Text style={styles.titleform}>{t('M2')}</Text>
                            <Text style={styles.titleform}>{sathtabadolhararat}</Text>
                            <Text style={styles.titleform}>{t('surfaceareaofheattransfer')}</Text>
                        </View>

                        <View style={styles.form}>
                            <Text style={styles.titleform}>{t('litre')}</Text>
                            <Text style={styles.titleform}>{gazgiri}</Text>
                            <Text style={styles.titleform}>{t('Circuitvol')}</Text>
                        </View>

                        <View style={styles.formodd}>
                            <Text style={styles.titleform}>{t('PCS')}</Text>
                            <Text style={styles.titleform}>{tedadfan}</Text>
                            <Text style={styles.titleform}>{t('Nooffans')}</Text>
                        </View>

                        <View style={styles.form}>
                            <Text style={styles.titleform}>{t('cm')}</Text>
                            <Text style={styles.titleform}>{ghotrefan}</Text>
                            <Text style={styles.titleform}>{t('FanDiameter')}</Text>
                        </View>

                        <View style={styles.formodd}>
                            <Text style={styles.titleform}>{t('m3hr')}</Text>
                            <Text style={styles.titleform}>{debi}</Text>
                            <Text style={styles.titleform}>{t('Airflow')}</Text>
                        </View>

                        <View style={styles.formodd}>
                            <Text style={styles.titleform}>{t('mm')}</Text>
                            <Text style={styles.titleform}>{faselefin}</Text>
                            <Text style={styles.titleform}>{t('Finspace')}</Text>
                        </View>

                        <View style={styles.form}>
                            <Text style={styles.titleform}>{t('inch')}</Text>
                            <Text style={styles.titleform}>{vorodi}</Text>
                            <Text style={styles.titleform}>{t('Inlet')}</Text>
                        </View>

                        <View style={styles.formodd}>
                            <Text style={styles.titleform}>{t('inch')}</Text>
                            <Text style={styles.titleform}>{khoroji}</Text>
                            <Text style={styles.titleform}>{t('Outlet')}</Text>
                        </View>

                        <View style={styles.form}>
                            <Text style={styles.titleform}>{t('kg')}</Text>
                            <Text style={styles.titleform}>{vazn}</Text>
                            <Text style={styles.titleform}>{t('Weight')}</Text>
                        </View>



                    </View>
                    : null}
                {selectwhich == 2 && datacondflat.length > 0 ?
                    <View style={[styles.container, { width: '100%' }]}>



                        <View style={styles.header}>
                            <Text style={styles.titleheader}>{t('fanspecifications')}</Text>
                        </View>



                        <View style={styles.form}>
                            <Text style={styles.titleform}>{t('RPM')}</Text>
                            <Text style={styles.titleform}>{sorat}</Text>
                            <Text style={styles.titleform}>{t('speed')}</Text>
                        </View>


                        <View style={styles.formodd}>
                            <Text style={styles.titleform}></Text>
                            <Text style={styles.titleform}>{ip}</Text>
                            <Text style={styles.titleform}>IP</Text>
                        </View>


                        <View style={styles.form}>
                            <Text style={styles.titleform}>{t('V')}</Text>
                            <Text style={styles.titleform}>{voltajfan}</Text>
                            <Text style={styles.titleform}>{t('Voltage')}</Text>
                        </View>

                        <View style={styles.formodd}>
                            <Text style={styles.titleform}>{t('Hz')}</Text>
                            <Text style={styles.titleform}>{ferekans}</Text>
                            <Text style={styles.titleform}>{t('Frequency')}</Text>
                        </View>


                        <View style={styles.form}>
                            <Text style={styles.titleform}>{t('A')}</Text>
                            <Text style={styles.titleform}>{jaryanfan}</Text>
                            <Text style={styles.titleform}>{t('Current')}</Text>
                        </View>


                        <View style={styles.formodd}>
                            <Text style={styles.titleform}>{t('KW')}</Text>
                            <Text style={styles.titleform}>{tavanfan}</Text>
                            <Text style={styles.titleform}>{t('Power')}</Text>
                        </View>



                        <View style={styles.header}>
                            <Text style={styles.titleheader}>{t('Connections')}</Text>
                        </View>

                        <View style={styles.form}>
                            <Text style={styles.titleform}>{t('inch')}</Text>
                            <Text style={styles.titleform}>{vorodireciver}</Text>
                            <Text style={styles.titleform}>{i18n.t('InletReciver')}</Text>
                        </View>

                        <View style={styles.formodd}>
                            <Text style={styles.titleform}>{t('inch')}</Text>
                            <Text style={styles.titleform}>{khorojireciver}</Text>
                            <Text style={styles.titleform}>{i18n.t('OutletReciver')}</Text>
                        </View>

                    </View>
                    : null}
                {selectwhich == 3 && datacondflat.length > 0 ?
                    <View style={[styles.container, { width: '100%' }]}>
                        <View style={styles.header}>
                            <Text style={styles.titleheader}>{t('schematic')}</Text>
                        </View>
                        <View>
                            {
                                (props.route.params.WHICH == 1 || props.route.params.WHICH == 2 ?
                                    <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: 30 }}>


                                        <TouchableOpacity onPress={() => { seturlshematic(urlshematicboland) }} style={{ borderBottomColor: '#e6e6e6', borderBottomWidth: 2, padding: 10, }}>
                                            <Text style={{ fontFamily: 'IranSans', fontSize: 13, color: 'blue' }}>پایه بلند</Text>
                                        </TouchableOpacity>
                                        <TouchableOpacity onPress={() => { seturlshematic(urlshematickotah) }} style={{ borderBottomColor: '#e6e6e6', borderBottomWidth: 2, padding: 10, }}>
                                            <Text style={{ fontFamily: 'IranSans', fontSize: 13, color: 'blue' }}>پایه کوتاه</Text>
                                        </TouchableOpacity>




                                    </View> : null
                                )
                            }


                            {urlshematic != "" && <View>
                                <TouchableOpacity onPress={() => { setIsOpen(true) }}>
                                    <Image style={{
                                        flex: 1, flexDirection: 'column', width: 400, height: 400, resizeMode: 'contain',
                                        alignSelf: 'center'
                                    }} source={urlshematic}
                                    />
                                </TouchableOpacity>
                            </View>



                            }


                            {isOpen && urlshematic != "" && <Lightbox
                                mainSrc={urlshematic}
                                onCloseRequest={() => { setIsOpen(false); }}
                            />}









                        </View>
                    </View>
                    : null}

                <ReactToPrint
                    documentTitle={selectedmodeltitle}
                    trigger={() => <button style={{ margin: 15, padding: '7px 40px', direction: 'rtl', fontFamily: 'IranSans', cursor: 'pointer   ', fontSize: 12.8, verticalAlign: 'center', background: '#08598e', color: '#fff', border: 'none', borderRadius: 7, display: 'inline-flex' }}><img src="https://app.arshehkar.com/gallery/icons/exortpdf.png" style={{ width: 45, paddingLeft: 10 }} /><p>{t('Exporttopdf')}</p></button>}
                    content={() => componentRef.current}
                />
                <div style={{ display: "none" }}>
                    <ComponentToPrintCondonser person={{
                        zarfiyatnami: zarfiyatnami,
                        axevaprator: urlshematic,
                        selectedmodeltitle: selectedmodeltitle,
                        sathtabadolhararat: sathtabadolhararat,
                        gazgiri: gazgiri,
                        tedadfan: tedadfan,
                        ghotrefan: ghotrefan,
                        debi: debi,
                        faselefin: faselefin,
                        vorodi: vorodi,
                        khoroji: khoroji,
                        vazn: vazn,
                        sorat: sorat,
                        ip: ip,
                        voltajfan: voltajfan,
                        ferekans: ferekans,
                        jaryanfan: jaryanfan,
                        tavanfan: tavanfan,
                        vorodireciver: vorodireciver,
                        khorojireciver: khorojireciver,
                    }} ref={componentRef} />
                </div>

            </SafeAreaView>
        </ScrollView>
    )
}

export default ResultCondenser;
const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        backgroundColor: '#fff',

    }
    ,
    titleform: {
        marginBottom: 10,
        marginTop: 10,
        fontFamily: 'IranSans',
        fontSize: 13,
        flex: 1,
        textAlign: 'center'
    }
    ,
    inputtext: {
        backgroundColor: '#fff',
        textAlign: 'center',
        borderColor: "gray",
        width: "100%",
        borderWidth: 1,
        borderRadius: 10,
        padding: 10, width: '100%', height: 30
    }
    ,
    dropdown: {
        height: 50,
        width: '100%',

        fontFamily: 'IranSans',
        fontSize: 13,
        borderWidth: 0,
        textAlign: 'center',
        backgroundColor: '#c9c9c9',
        direction: 'rtl',
        padding: 10,



    },
    form: {
        width: '90%',
        backgroundColor: '#ddd',
        margin: 2,
        padding: 5,
        justifyContent: 'center',
        alignItems: 'stretch',
        flex: 1,
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'flex-start'
    },
    formodd: {
        width: '90%',
        backgroundColor: '#e6e6e6',
        margin: 2,
        padding: 5,
        justifyContent: 'center',
        alignItems: 'stretch',
        flex: 1,
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'flex-start'
    }
    ,
    header: {
        width: '90%',
        backgroundColor: '#022a4c',
        margin: 10,
        padding: 10,
        justifyContent: 'center',
        alignItems: 'stretch',
        shadowColor: '#000',
        shadowOffset: { width: 1, height: 0.5 },
        shadowOpacity: 0.7,
        shadowRadius: 3,
        flex: 1,
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'flex-start'
    },
    headertop: {
        width: '90%',
        backgroundColor: '#82f7ff',
        margin: 10,
        padding: 10,
        justifyContent: 'center',
        alignItems: 'stretch',
        shadowColor: '#000',
        shadowOffset: { width: 1, height: 0.5 },
        shadowOpacity: 0.7,
        shadowRadius: 3,
        flex: 1,
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'flex-start'
    },
    titleheader: {
        marginBottom: 10,
        marginTop: 10,
        fontFamily: 'IranSans',
        fontSize: 14,
        flex: 1,
        textAlign: 'center',
        color: 'white'
    }
    ,
    touchable: {
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 12,
        paddingHorizontal: 32,
        borderRadius: 4,
        elevation: 3,
        backgroundColor: '#4db6ac',
        marginBottom: 15,
        margin: 15,
        shadowColor: '#000',
        shadowOffset: { width: 1, height: 0.5 },
        shadowOpacity: 0.7,
        shadowRadius: 3,
    },
    titlebutton: {

        fontSize: 13,
        lineHeight: 21,
        fontWeight: 'bold',
        fontFamily: 'IranSans',
        letterSpacing: 0.25,
        color: 'white',

    },
    spinner: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: 'rgba(50,70,110,0.3)',
        bottom: 0,
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9000,
    }
    ,
    titlepicker: {
        fontSize: 14, fontFamily: 'IranSans', width: '90%', textAlign: 'right', padding: 7
    }
});